import {
    ChangeDetectionStrategy,
    Component,
    Input,
    OnInit,
} from '@angular/core';
import { ContentfulService } from '@core/services/contentful.service';
import { LazyAssetComponent } from '@features/lazy-image/components/lazy-asset/lazy-asset.component';
import { CropFocus } from '@features/lazy-image/components/lazy-picture/lazy-picture.component';
import { KnowledgeArticle } from '@generated/graphql';

import { AssetImageConfiguration } from '@features/lazy-image/components/lazy-asset-lazy/lazy-asset-lazy.component';
import { LinkComponent } from '../../../shared/link/link.component';

@Component({
    selector: 'app-knowledge-article-card',
    templateUrl: './knowledge-article-card.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [LinkComponent, LazyAssetComponent],
})
export class KnowledgeArticleCardComponent implements OnInit {
    @Input() article: KnowledgeArticle;
    @Input() lazy: boolean = true;
    imageConfiguration: AssetImageConfiguration;
    constructor(private contentfulService: ContentfulService) {}

    ngOnInit(): void {
        this.imageConfiguration = {
            image: this.article?.featuredImageSquare,
            ratioWidth: 16,
            ratioHeight: 9,
            width: 400,
            width2x: 800,
            focus:
                (this.article?.featuredImageCropFocus as CropFocus) || 'center',
        };
    }

    preloadArticle() {
        this.contentfulService.article(this.article.urlSlug).subscribe();
    }
}
